export enum Initiator {
	PHOTOS = "photos",
	UPLOADS = "uploads",
	LIVE_VIDEO = "live-video",
	SCHEDULED_VIDEO = "scheduled-video",
	REQUESTED_RECORDING = "requested-recording",
	RECORDING = "recording",
	FORM = "form"
}

export function getIconForInitiator(initiator: Initiator): string {
	switch (initiator) {
		case Initiator.PHOTOS:
			return "icon-camera-solid";
		case Initiator.UPLOADS:
			return "icon-cloud-stroke-upload";
		case Initiator.LIVE_VIDEO:
			return "icon-conversation-stroke";
		case Initiator.SCHEDULED_VIDEO:
			return "icon-calendar-stroke";
		case Initiator.REQUESTED_RECORDING:
			return "icon-paper-plane-stroke";
		case Initiator.RECORDING:
			return "icon-recording-circle";
		case Initiator.FORM:
			return "icon-qr-code";
	}
	return "";
}

export function getColorForInitiator(initiator: Initiator): string {
	switch (initiator) {
		case Initiator.PHOTOS:
			return "photos-icon";
		case Initiator.UPLOADS:
			return "uploads-icon";
		case Initiator.LIVE_VIDEO:
			return "live-video-icon";
		case Initiator.SCHEDULED_VIDEO:
			return "schedule-fab-icon";
		case Initiator.REQUESTED_RECORDING:
			return "request-recording-fab-icon";
		case Initiator.RECORDING:
			return "recording-icon";
		case Initiator.FORM:
			return "form-icon";
	}
	return "";
}
